
import {useEntity} from "react-admin-base";
import { EntityEditor} from 'react-admin-base-bootstrap';
import {Breadcrumb} from 'react-admin-base-nazox';

import { Navigate, useParams } from "react-router-dom";
import { Col, Input, Row } from "reactstrap";
import { ContentInput } from '../../Components/ContentInput';
import { Field } from "../../Components/Fields";

export default function CourseEntity() {
    const { id } = useParams();
    const entity = useEntity('/course', id, { values: { } });
    const [data, setData] = entity;

    return <Breadcrumb
        data={
            [
                {
                    href: '/course',
                    name: 'Courses'
                },
                {
                    href: id ? '/course/' + data.id + '/edit' : '/course/create',
                    name: id ? 'Edit' : 'Create'
                }
            ]
        }
    >
        { !id && data.id && <Navigate to={"../" + data.id + "/edit"} replace />}
        <EntityEditor entity={entity}>
            <Row>
                <Col>
                    <Field title="LMS Course ID">
                        <Input
                            type="text"
                            value={data.lms_course_id || ''}
                            onChange={a => setData({ lms_course_id: a.currentTarget.value })}
                        />
                    </Field>
                </Col>
            </Row>
            <ContentInput
                value={data.content}
                onChange={a => setData({ content: a })}
            />
        </EntityEditor>
    </Breadcrumb>;
}
